import React from "react";

const ClientContext = React.createContext({
  apps: {} as any,
  customization: {} as any,
});

export default ClientContext;
